export default "__VITE_ASSET__BEWbCMka__"